module.exports = "/images/slide-qs-t-11.jpg";